import axios from 'axios'
import store from '../index'
import { make } from 'vuex-pathify'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'
import { formatDate } from '@/util/formatters'

const state = {
  provider: {
    addresses: [],
  },

  providers: {
    data: [],
    count: 0,
    limit: 50,
  },

  filter: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ['name'],
    sortDesc: [false],
  },

  providerStats: {
    data: {},
    dialog: false,
  },

  type: 'add',
  loading: false,
  dialog: false,
  dialogUpdate: false,
}

const mutations = make.mutations(state)

const actions = {
  add: ({ state }) => {
    state.provider = {
      addresses: [],
      active: true,
      companyId: store.get('authStore@currentCompany').id,
    }
    state.type = 'add'
    state.dialog = true
  },

  edit: ({ state }, id) => {
    state.loading = true
    store.dispatch('providerStore/getById', id)
      .then(res => {
        state.provider = res.data

        state.type = 'edit'
        state.dialog = true
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  view: ({ state }, id) => {
    state.loading = true
    store.dispatch('providerStore/getById', id)
      .then(res => {
        state.provider = res.data

        state.type = 'view'
        state.dialog = true
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  getProviderStats: ({ state }, id) =>
    axios.get(`${process.env.VUE_APP_API_URL}/provider-stats/${id}`)
      .then(res => {
        state.providerStats.data = res.data

        // format data
        state.providerStats.data.lastRequest = res.data.lastRequest
          ? formatDate(new Date(res.data.lastRequest).toISOString().substr(0, 10))
          : null
        state.providerStats.data.mostRequestedProduct = res.data.mostRequestedProduct
          ? `${res.data.mostRequestedProduct.name} - Quantidade vendida: ${res.data.mostRequestedProduct.sum}`
          : 'Nenhum produto encontrado'
      })
      .catch(showError),

  showProviderStats: ({ state }, id) => {
    state.loading = true
    store.dispatch('providerStore/getProviderStats', id)
      .then(_ => {
        state.providerStats.dialog = true
      })
      .finally(() => (state.loading = false))
  },

  save: ({ state }, provider) => {
    const id = provider.id
    const method = id ? 'put' : 'post'

    state.loading = true
    const payload = { ...provider }
    delete payload.imgUrl
    return axios[method](`${process.env.VUE_APP_API_URL}/provider/${id || ''}`, payload)
      .then((res) => {
        state.dialog = false
        store.dispatch('providerStore/get')
        showSuccess('Fornecedor salvo com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  get: async ({ state }, filter = state.filter) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/provider?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.providers = res.data
        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  getById: (context, id) => axios.get(`${process.env.VUE_APP_API_URL}/provider/${id}`).catch(showError),

  getByCnpj: async ({ state }, cnpj) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/provider?${getQueryFromFilter({ cnpj })}`)
      .then(res => {
        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  remove: ({ state }, id) => {
    state.loading = true
    return axios.delete(`${process.env.VUE_APP_API_URL}/provider/${id}`)
      .then(_ => {
        store.dispatch('providerStore/get')
        showSuccess('Fornecedor excluído com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },
}

const getters = {
  getById: state => id => {
    return state.providers.data.find((u) => String(u.id) === String(id))
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
